<template>
  <div>
    <header-desktop></header-desktop>
    <main
      class="layoutSubKenoResult layoutSubMain min-vh-100"
      :class="{
        pt40: isPlayTrialModeMobile
      }"
    >
      <UIBanner
        :classLoading="'placeholders-banner-game'"
        class="d-none d-lg-block"
        :keyData="'w_recent_result'"
        :classImage="'img-common'"
      />
      <div class="container mb-3 mb-lg-0">
        <!-- <ListGame :listGame="listGame" :value="activedGame" @handlerActiveGame="handlerActiveGame" /> -->
        <router-view @updateGameId="updateGameId" :key="$route.path + reloadFlagResultScreen" />
      </div>
      <div v-if="isThanhCo" class="scanAndStatisticalAction scanAndStatisticalAction--thanhco">
        <!-- <a
          v-if="gameId && !['xsmn'].includes(this.listGameById[gameId].handler)"
          id="scanResult"
          @click="handleScanPress()"
          class="btnScan pointer"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M2.39999 6.90001C2.39999 6.02479 2.74767 5.18542 3.36654 4.56655C3.98541 3.94768 4.82478 3.60001 5.69999 3.60001H6.59999C6.83869 3.60001 7.06761 3.69483 7.23639 3.86361C7.40517 4.03239 7.49999 4.26131 7.49999 4.50001C7.49999 4.7387 7.40517 4.96762 7.23639 5.1364C7.06761 5.30518 6.83869 5.40001 6.59999 5.40001H5.69999C4.87199 5.40001 4.19999 6.07201 4.19999 6.90001V7.80001C4.19999 8.0387 4.10517 8.26762 3.93639 8.4364C3.76761 8.60518 3.53869 8.70001 3.29999 8.70001C3.0613 8.70001 2.83238 8.60518 2.6636 8.4364C2.49481 8.26762 2.39999 8.0387 2.39999 7.80001V6.90001ZM16.5 4.50001C16.5 4.26131 16.5948 4.03239 16.7636 3.86361C16.9324 3.69483 17.1613 3.60001 17.4 3.60001H18.3C19.1752 3.60001 20.0146 3.94768 20.6334 4.56655C21.2523 5.18542 21.6 6.02479 21.6 6.90001V7.80001C21.6 8.0387 21.5052 8.26762 21.3364 8.4364C21.1676 8.60518 20.9387 8.70001 20.7 8.70001C20.4613 8.70001 20.2324 8.60518 20.0636 8.4364C19.8948 8.26762 19.8 8.0387 19.8 7.80001V6.90001C19.8 6.07201 19.128 5.40001 18.3 5.40001H17.4C17.1613 5.40001 16.9324 5.30518 16.7636 5.1364C16.5948 4.96762 16.5 4.7387 16.5 4.50001ZM3.29999 15.3C3.53869 15.3 3.76761 15.3948 3.93639 15.5636C4.10517 15.7324 4.19999 15.9613 4.19999 16.2V17.1C4.19999 17.928 4.87199 18.6 5.69999 18.6H6.59999C6.83869 18.6 7.06761 18.6948 7.23639 18.8636C7.40517 19.0324 7.49999 19.2613 7.49999 19.5C7.49999 19.7387 7.40517 19.9676 7.23639 20.1364C7.06761 20.3052 6.83869 20.4 6.59999 20.4H5.69999C4.82478 20.4 3.98541 20.0523 3.36654 19.4335C2.74767 18.8146 2.39999 17.9752 2.39999 17.1V16.2C2.39999 15.9613 2.49481 15.7324 2.6636 15.5636C2.83238 15.3948 3.0613 15.3 3.29999 15.3ZM20.7 15.3C20.9387 15.3 21.1676 15.3948 21.3364 15.5636C21.5052 15.7324 21.6 15.9613 21.6 16.2V17.1C21.6 17.9752 21.2523 18.8146 20.6334 19.4335C20.0146 20.0523 19.1752 20.4 18.3 20.4H17.4C17.1613 20.4 16.9324 20.3052 16.7636 20.1364C16.5948 19.9676 16.5 19.7387 16.5 19.5C16.5 19.2613 16.5948 19.0324 16.7636 18.8636C16.9324 18.6948 17.1613 18.6 17.4 18.6H18.3C19.128 18.6 19.8 17.928 19.8 17.1V16.2C19.8 15.9613 19.8948 15.7324 20.0636 15.5636C20.2324 15.3948 20.4613 15.3 20.7 15.3ZM6.59999 7.20001C6.83869 7.20001 7.06761 7.29483 7.23639 7.46361C7.40517 7.63239 7.49999 7.86131 7.49999 8.10001V15.9C7.49999 16.1387 7.40517 16.3676 7.23639 16.5364C7.06761 16.7052 6.83869 16.8 6.59999 16.8C6.3613 16.8 6.13238 16.7052 5.9636 16.5364C5.79481 16.3676 5.69999 16.1387 5.69999 15.9V8.10001C5.69999 7.86131 5.79481 7.63239 5.9636 7.46361C6.13238 7.29483 6.3613 7.20001 6.59999 7.20001ZM11.1 8.10001C11.1 7.86131 11.0052 7.63239 10.8364 7.46361C10.6676 7.29483 10.4387 7.20001 10.2 7.20001C9.9613 7.20001 9.73238 7.29483 9.5636 7.46361C9.39481 7.63239 9.29999 7.86131 9.29999 8.10001V15.9C9.29999 16.1387 9.39481 16.3676 9.5636 16.5364C9.73238 16.7052 9.9613 16.8 10.2 16.8C10.4387 16.8 10.6676 16.7052 10.8364 16.5364C11.0052 16.3676 11.1 16.1387 11.1 15.9V8.10001ZM13.8 7.20001C14.0387 7.20001 14.2676 7.29483 14.4364 7.46361C14.6052 7.63239 14.7 7.86131 14.7 8.10001V15.9C14.7 16.1387 14.6052 16.3676 14.4364 16.5364C14.2676 16.7052 14.0387 16.8 13.8 16.8C13.5613 16.8 13.3324 16.7052 13.1636 16.5364C12.9948 16.3676 12.9 16.1387 12.9 15.9V8.10001C12.9 7.86131 12.9948 7.63239 13.1636 7.46361C13.3324 7.29483 13.5613 7.20001 13.8 7.20001ZM18.3 8.10001C18.3 7.86131 18.2052 7.63239 18.0364 7.46361C17.8676 7.29483 17.6387 7.20001 17.4 7.20001C17.1613 7.20001 16.9324 7.29483 16.7636 7.46361C16.5948 7.63239 16.5 7.86131 16.5 8.10001V15.9C16.5 16.1387 16.5948 16.3676 16.7636 16.5364C16.9324 16.7052 17.1613 16.8 17.4 16.8C17.6387 16.8 17.8676 16.7052 18.0364 16.5364C18.2052 16.3676 18.3 16.1387 18.3 15.9V8.10001Z"
              fill="#333333"
            />
          </svg>
          <span class="ml-2">
            Dò vé
          </span>
        </a> -->
        <a
          v-if="gameId && !['max3d', 'max3d+', 'max3dpro', 'max4d', 'xsmn'].includes(this.listGameById[gameId].handler)"
          id="statistical"
          @click="handlerLink(gameId)"
          class="btnFilterLinkStatistical pointer"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.65 9.45H6.85C7.62 9.45 8.25 10.08 8.25 10.85V17.85C8.25 18.62 7.62 19.25 6.85 19.25H6.65C5.88 19.25 5.25 18.62 5.25 17.85V10.85C5.25 10.08 5.88 9.45 6.65 9.45ZM12.25 5.25C13.02 5.25 13.65 5.88 13.65 6.65V17.85C13.65 18.62 13.02 19.25 12.25 19.25C11.48 19.25 10.85 18.62 10.85 17.85V6.65C10.85 5.88 11.48 5.25 12.25 5.25ZM17.85 13.25C18.62 13.25 19.25 13.88 19.25 14.65V17.85C19.25 18.62 18.62 19.25 17.85 19.25C17.08 19.25 16.45 18.62 16.45 17.85V14.65C16.45 13.88 17.08 13.25 17.85 13.25Z"
              fill="white"
            />
          </svg>
          <span class="ml-2">Thống kê</span>
        </a>
      </div>
      <div v-else class="scanAndStatisticalAction">
        <a
          v-if="gameId && !['xsmn'].includes(this.listGameById[gameId].handler) && !isProduction"
          id="scanResult"
          @click="handleScanPress()"
          class="btnScan pointer"
        >
          <img src="../assets/img/icon/scan.svg" />
        </a>
        <a
          v-if="gameId && !['max3d', 'max3d+', 'max3dpro', 'max4d', 'xsmn'].includes(this.listGameById[gameId].handler)"
          id="statistical"
          @click="handlerLink(gameId)"
          class="btnFilterLinkStatistical pointer"
        >
          <img src="../assets/img/icon/icon_thongke.svg" />
        </a>
      </div>
    </main>
    <Footer></Footer>
    <NavbarMobile class="d-block d-lg-none"></NavbarMobile>
  </div>
</template>
<script>
import UIBanner from '@/components/UI/Banner/UIBanner';
import HeaderDesktop from '../components/HeaderDesktop';
// import ListGame from '../components/KenoResult/ListGame';
import Footer from '../components/Footer';
import NavbarMobile from '../components/NavbarMobile';
import GameAppService from '../api/game';
import { GameUrlSubMainResult } from '../api/mock/enum';
export default {
  name: `MainApp`,
  components: {
    HeaderDesktop,
    Footer,
    NavbarMobile,
    UIBanner
    // ListGame
  },
  data() {
    return {
      activedGame: '',
      gameUrl: GameUrlSubMainResult,
      listGame: [],
      gameId: 0
    };
  },
  created() {
    this.getListGame();
    this.activedGame = this.getterResultGame[0].url;
  },

  methods: {
    handlerLink(gameId) {
      let router = this.getRouteStatisticalByGameId(gameId);
      this.$router.push(router);
      this.$store.commit('setHistoryResult', true);
    },
    handleScanPress() {
      if (window.ReactNativeWebView) {
        this.sendMessageToApp(JSON.stringify({ event: 'REQUEST_SCANNER' }));
      } else {
        this.$router.push('/do-ve');
      }
    },
    updateGameId(id) {
      this.gameId = id;
    },
    getListGame() {
      this.$store.commit('setIsLoadingProduct', true);
      GameAppService.getListGame()
        .then((resp) => {
          let data = resp.data.data;
          // .sort((a) => {
          //   if (a.handler === 'xsmn') {
          //     return -1;
          //   } else {
          //     return 0;
          //   }
          // });
          const listHidden = ['max3d+', 'max4d', 'xsmn'];
          data.forEach((m) => {
            if (listHidden.includes(this.listGameById[m.id].handler)) {
              return;
            }
            var o = Object.assign({}, m);
            let game = this.getterResultGame.find((f) => f.id == o.id);
            o.url_link = game ? game.url : '';
            this.listGame.push(o);
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.$store.commit('setIsLoadingProduct', false);
        });
    },
    handlerActiveGame(newVal) {
      this.activedGame = newVal;
    }
  },
  computed: {
    getterResultGame() {
      return this.$store.getters.getterResultGameUrl;
    },
    reloadFlagResultScreen() {
      return this.$store.getters.getterReloadFlagResultScreen;
    },
    listGameById() {
      return this.$store.getters.getterListGame;
    }
  }
};
</script>
<style lang="scss" scoped>
// @import "../assets/sass/main";

.scanAndStatisticalAction {
  position: sticky;
  left: 85%;
  bottom: 50px;
  display: inline-flex;
  flex-direction: column;

  .btnScan {
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    background-color: #dcdcdc;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .btnFilterLinkStatistical {
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    background-color: #0d234a;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
  }

  &--thanhco {
    position: fixed;
    bottom: 75px !important;
    left: 0;
    width: 100%;
    display: flex;
    flex-direction: row;
    padding: 0 15px;

    .btnFilterLinkStatistical,
    .btnScan {
      border-radius: 3px;
      flex-grow: 1;
      text-transform: uppercase;
      font-weight: 700;
      display: flex;
      align-items: center;
      box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);

      &:nth-child(2) {
        margin-left: 16px;
      }
    }
    .btnScan {
      background-color: #ffd764;
    }
    .btnFilterLinkStatistical {
      // background-color: #0d234a;
      color: #ffffff;
      margin-top: 0;
    }
  }
}
</style>
